<div class="bg-white border border-gray-200 rounded-lg text-sm">
  <div class="p-3 flex items-center bg-gray-100">
    <div class="flex gap-2 items-center flex-auto" cdkDragHandle>
      <mat-icon>volume_up</mat-icon>

      <span class="font-medium">Spraak</span>
    </div>

    <div class="flex">
      <ng-template
        [ngTemplateOutlet]="actions() ?? null"
        [ngTemplateOutletContext]="{ $implicit: data() }"
      />
    </div>
  </div>

  <div class="p-3 border-t border-inherit">
    <div class="flex gap-1 items-center">
      <button
        mat-icon-button
        class="inline-flex! size-8! p-1! -ml-1"
        [matTooltip]="isTtsPlaying() ? 'Spraak stoppen' : 'Spraak afspelen'"
        (click)="handleTtsPlayback()"
      >
        <mat-icon>{{ isTtsPlaying() ? 'stop' : 'play_arrow' }}</mat-icon>
      </button>
      <span class="break-words min-w-0 flex-auto" [innerHTML]="data().value | highlightVariables"></span>
    </div>
  </div>
</div>
